<template>
  <div class="uk-child-width-1-2@s uk-child-width-1-5@m uk-text-center uk-grid-medium" uk-lightbox="animation: slide" uk-grid>
    <template v-for="u in instagram">
      <div v-for="i in u.images.slice(0, 3)" :key="i.node.id">
        <a :href="i.node.display_url" class="uk-inline-clip uk-transition-toggle" tabindex="0">
          <img :src="i.node.thumbnail_src" class="uk-transition-scale-up uk-transition-opaque" />
        </a>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "Latest",
  data() {
    return {
      limit: 3,
      instagram: [{
        id: "studio8_beratibishi",
        profilePic: null,
        images: null,
      },
      {
        id: "granitibishi_studio8",
        profilePic: null,
        images: null,
      },
      {
        id: "lynnwindletattoo",
        profilePic: null,
        images: null,
      },
      {
        id: "tonton.tattoo",
        profilePic: null,
        images: null,
      }
      ],
    }
  },
  mounted() {
    this.instagram.forEach(o => this.loadPic(o.id));
  },
  methods: {
    loadPic: async function(username) {
      var pic = await this.fetchUsername(username);
      this.instagram.filter(o => o.id === username).forEach(o => o.profilePic = pic.graphql.user.profile_pic_url_hd);
      this.instagram.filter(o => o.id === username).forEach(o => o.images = pic.graphql.user.edge_owner_to_timeline_media.edges);
    },
    fetchUsername: async function(username) {
      return await fetch(`https://www.instagram.com/${username}/?__a=1`).then(r => r.json());
    },
  }
};
</script>
